import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import {
  initializeAuth,
  indexedDBLocalPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
  browserPopupRedirectResolver
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase web config
export const firebaseConfig = {
  apiKey: 'AIzaSyDlYk6h9djZu2bxGmoJXdj4ithE-Otd688',
  authDomain: 'crumbly-461ef.firebaseapp.com',
  projectId: 'crumbly-461ef',
  storageBucket: 'crumbly-461ef.firebasestorage.app',
  messagingSenderId: '987481031708',
  appId: '1:987481031708:web:36e3e5d6adbfdd9df24bd9',
  measurementId: 'G-N0K3MNNDS9',
};

// nitialize core app
const app = initializeApp(firebaseConfig);
const isNative = Capacitor.getPlatform() !== 'web';

// Initialize Auth with explicit persistence
// - indexedDBLocalPersistence is preferred (more robust in WKWebView)
// - browserLocalPersistence falls back to localStorage if IndexedDB is unavailable
export const auth = initializeAuth(app, {
  // keep your IndexedDB + localStorage persistence everywhere...
  persistence: [
    indexedDBLocalPersistence, 
    browserLocalPersistence
  ],
  // ...but only wire up the pop-up resolver on actual web
  ...(isNative
    ? {} 
    : { popupRedirectResolver: browserPopupRedirectResolver }
  )
});

// ── 3) Export Firestore & Google provider
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();